<div class="flex items-center justify-center min-h-screen bg-white">
    <div
        class="w-full max-w-[600px] sm:min-w-[544px] rounded-[20px] border border-[#E2E8F0] bg-white/90 p-8 shadow-xl backdrop-blur">
        <div class="w-full flex flex-col items-center gap-10">
            <img src="/assets/images/auth/interseed-new-logo.png" alt="interseed logo" class="h-16 w-auto" />

            <div class="size-16 rounded-full bg-[#F0F7FF] flex items-center justify-center">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#4F66FF"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-mail h-8 w-8"
                    aria-hidden="true">
                    <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                    <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                </svg>
            </div>
        </div>

        <div class="text-center mt-6">
            <p class="text-[#0A0A0A] text-xl font-bold">Check your inbox</p>
            <p class="text-[#717182] text-sm mt-3 max-w-[75%] mx-auto">
                We have sent a link to
                <span class="text-[#0A0A0A] font-semibold">{{ email }}</span
                >. Open it and tap the link to activate your account.
            </p>
        </div>

        <button
            type="button"
            class="w-full mt-2 p-2 text-center text-[#717182] hover:text-[#0A0A0A] text-sm font-semibold"
            (click)="resendVerifyEmail()">
            Resend Email
        </button>
        <p class="text-center mt-6 text-[#717182] text-xs">Check your spam folder if you don't see it.</p>
    </div>
</div>
